import { api } from "./api";

export async function getConvencao() {
  const payload = [{ $sort: { created: -1 } }, { $limit: 1 }] as any;

  payload.unshift({
    $match: {
      active: true,
    },
  });


  const { data } = await api.post(`database/convencao__c/aggregate`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}